import React, { useEffect } from 'react';
import NotificationContainer from '../NotificationContainer';

// import './style.scss';

function NotificationPage() {
  useEffect(() => {
    document.title = `Notiser - TFV Kundportal
    `;
  }, []);
  return (
    <div className="d-flex w-100">
      <NotificationContainer isPage />
    </div>
  );
}

NotificationPage.propTypes = {};

export default NotificationPage;
